import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { containerTurnoverService } from '@tom-ui/integration'
import { PATHS } from '@tom-ui/utils'
import { useCallback } from 'react'

export const useVesselVisitTableMenuOptions = () => {
  const { t } = useTranslate()

  const { appViewStore } = usePlanningStore()

  const onOrderHistory = useCallback(
    async (containerId: number, carrierVisitId?: number | null) => {
      const containerTurnovers = await containerTurnoverService.getByFilter(containerId)

      const carrierVisitTurnoverId = containerTurnovers.find(
        turnover =>
          turnover.InboundOrder?.CarrierVisitId === carrierVisitId ||
          turnover.OutboundOrder?.CarrierVisitId === carrierVisitId,
      )?.Id

      if (!carrierVisitTurnoverId) {
        appViewStore.setShowAlert(
          'error',
          t('containerHistoryNotFound', 'Container history not found'),
        )
        return
      }

      window.open(
        `${PATHS.masterData.containers.url}/${containerId}/${PATHS.masterData.containers.history.url}/${carrierVisitTurnoverId}`,
        '_blank',
      )
    },
    [],
  )

  return {
    onOrderHistory,
  }
}
